import './App.scss'
import { Root } from './pages/Root'

function App() {
	return <Root />
}

export default App
